module.exports = __webpack_public_path__ + "img/74.d8775791.jpg";